import * as React from 'react';
import dayjs from 'dayjs';
import { fetchApi } from '../../services/api';
import JsonPretty from '../../components/JsonPretty';
import { Dialog } from '@progress/kendo-react-dialogs';

interface Props {
  CloseDialog: () => void;
  DriverAccidentID: number,
}

type AuditLogViewModel = {
  DateTime: string;
  UserName: string;
  OldValues: string;
  NewValues: string;
}

type Response = {
  Logs: AuditLogViewModel[];
}

const DriverAccidentAuditLogs = (props: Props) => {

  const [logs, setLogs] = React.useState<AuditLogViewModel[]>([]);

  React.useEffect(() => {
    fetchApi(`/api/Asset/DriverAccidentAuditLogs/${props.DriverAccidentID}`)
      .then((response: Response) => {
        setLogs(response.Logs);
      })
  }, [props.DriverAccidentID]);

  return (
    <Dialog title="Audit Logs" onClose={props.CloseDialog} className='dialog-w1140'>
      <table className="table" style={{ tableLayout: 'fixed', wordWrap: 'break-word' }}>
        <thead>
          <tr>
            <th style={{ width: '16.66%' }}>User</th>
            <th style={{ width: '16.66%' }}>Timestamp</th>
            <th style={{ width: '33.33%' }}>Old Values</th>
            <th style={{ width: '33.33%' }}>New Values</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log, index) => {
            return <tr key={index}>
              <td>{log.UserName}</td>
              <td>{dayjs.utc(log.DateTime).local().format("YYYY-MM-DD HH:mm:ss")}</td>
              <td><JsonPretty json={log.OldValues} /></td>
              <td><JsonPretty json={log.NewValues} /></td>
            </tr>
          })}
        </tbody>
      </table>
    </Dialog>
  );
}

export default DriverAccidentAuditLogs;
